module.exports = __webpack_public_path__ + "assets/media/lunch.90581e56.mp3";